"use client";
import { j as x } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as l } from "./tv.config-BuYIgndg.mjs";
import { u as c } from "./useRender-DCcXqLqs.mjs";
import { m as i } from "./useRenderElement-B8V3_e8R.mjs";
const d = l({
  base: ["Container__root container xs:px-6 px-4 box-border block"],
  variants: {
    maxWidth: {
      xs: "max-w-screen-xs",
      sm: "max-w-screen-sm",
      md: "max-w-screen-md",
      lg: "max-w-screen-lg",
      xl: "max-w-screen-xl"
    },
    disableGutters: {
      true: ["!px-0"]
    }
  },
  defaultVariants: {
    maxWidth: "xl"
  }
}), g = (e) => {
  const { render: s, maxWidth: r, disableGutters: t, className: a, ...n } = e, m = s ?? /* @__PURE__ */ x.jsx("div", {}), o = {
    className: d({
      maxWidth: r,
      disableGutters: t,
      class: a
    })
  };
  return c({
    render: m,
    props: i(o, n)
  });
};
export {
  g as default
};
